import { all } from 'redux-saga/effects';
import addressBookSagas from './AddressBook/sagas.js';
import stepShippingSagas from './StepShipping/sagas.js';

/**
 * Checkout root saga
 */ function* sagas() {
    yield all([
        ...stepShippingSagas,
        ...addressBookSagas
    ]);
}

export { sagas as default };
//# sourceMappingURL=sagas-registry.js.map
